module.exports = __webpack_public_path__ + "img/visto.5ff73d03.svg";